import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TimeKeeperEmployerState {
  id: string;
  name: string;
  reference: number;
  props: {
    [key: string]: any;
  };
}

const initialState: TimeKeeperEmployerState = {
  id: '',
  name: '',
  reference: 0,
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const laborSlice = createSlice({
  name: 'timeKeeperEmployer',
  initialState,
  reducers: {
    setTimeKeeperEmployer: (state, action: PayloadAction<Partial<TimeKeeperEmployerState>>) => {
      return { ...state, ...action.payload };
    },

    resetProps: (_state, action: PayloadAction<Partial<TimeKeeperEmployerState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: TimeKeeperEmployerState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setTimeKeeperEmployer, resetProps, updateField, updateProps } = laborSlice.actions;

export default laborSlice.reducer;
